var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "error",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.22 30h19.56a4.39 4.39 0 0 0 3.33-1.43 4.19 4.19 0 0 0 .6-4.67L19.82 4.12a4.31 4.31 0 0 0-2.57-2.26 4.24 4.24 0 0 0-5 2.15L2.29 23.9a4.19 4.19 0 0 0 .6 4.67A4.39 4.39 0 0 0 6.22 30Zm-2.14-5.2L14 5a2.62 2.62 0 0 1 1.82-1.32A2.19 2.19 0 0 1 18 4.91l9.9 19.8a2.32 2.32 0 0 1 .21 1.65A2.22 2.22 0 0 1 26 28H6.14a2.27 2.27 0 0 1-1.56-.56 2.2 2.2 0 0 1-.5-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.9a1 1 0 0 0 1-1v-15a1 1 0 1 0-2 0v15a1 1 0 0 0 1 1zm0 3.2a1 1 0 0 0 1-1v-.16a1 1 0 1 0-2 0v.16a1 1 0 0 0 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.301f4beb8a27a110b2c72af962ce3682.svg";
export { ForwardRef as ReactComponent };